import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, FormActions, Select } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import validators from '../../common/services/validators';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, grades, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<Select name='gradeId' data={grades} label={t('WeeklyInformation_Grade')} />
						</Col>
						<Col sm={6}>
							<Field name='weekNumber' component={Input} type='text' label={t('WeeklyInformation_WeekNumber')} validate={[validators.number]} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='isOnline' component={Input} componentClass='select' label={t('WeeklyInformation_IsOnline')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'weeklyInformationsFilter' })(withTranslation()(Filter));